import { ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'gcc-validation-message',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.scss'],
  standalone: false
})
export class ValidationMessageComponent {
  @HostBinding('class') public className = 'caption text-red mt-1';
  @HostBinding('style.display')
  get display() {
    return this._hidden ? 'none' : '';
  }

  get hidden() {
    return this._hidden;
  }
  set hidden(h: boolean) {
    this._hidden = h;
    this.cdr.markForCheck();
  }

  @Input() public for: string;

  private _hidden = true;

  constructor(private cdr: ChangeDetectorRef) {}
}
